<template>
    <div class="row">
            <div class="col-md-12 loader-spinner-graph">
                <div class="loadingio-spinner-wedges-r4aozssjb1">
                    <div class="ldio-brup1v2qwjn">
                        <div>
                            <div><div></div></div>
                            <div><div></div></div>
                            <div><div></div></div>
                            <div><div></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: 'loader-circle',
        data() {
            return {
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>